import React from 'react';
import { Calendar } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../components/ui/button';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ConveningRegister = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div id="main-content" role="main" tabIndex={-1} className="min-h-screen bg-gradient-to-br from-[#0A2037] via-[#0d2a45] to-[#079897] flex items-center justify-center pt-20 px-4">
        <div className="max-w-lg w-full bg-white rounded-2xl shadow-2xl p-10 text-center" data-testid="convening-closed">
          <div className="w-20 h-20 bg-slate-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <Calendar className="w-10 h-10 text-slate-400" />
          </div>
          <h2 className="text-2xl font-bold text-slate-800 mb-3">Registration is Now Closed</h2>
          <p className="text-slate-600 mb-2">Thank you for your interest in the</p>
          <p className="text-lg font-semibold text-[#079897] mb-6">Stronger Together: Protecting Progress Through Collective Leadership</p>
          <p className="text-slate-500 text-sm mb-6">
            Registration for this convening has closed. If you have any questions, please contact us at{' '}
            <a href="mailto:admin@dcelc.org" className="text-[#079897] underline">admin@dcelc.org</a>.
          </p>
          <Button
            onClick={() => navigate('/')}
            className="bg-gradient-to-r from-teal-500 to-emerald-600 hover:from-teal-600 hover:to-emerald-700 text-white px-8"
            data-testid="convening-back-home-btn"
          >
            Back to Homepage
          </Button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default ConveningRegister;
